module.exports = __webpack_public_path__ + "media/site/images/products/actionplan-flat-screen-7b8c8c3bcd2bee4b551bddbb6ae24391.png";